<form
  class="connect-bg connect-channel"
  (ngSubmit)="addWebchat()"
  #webchatForm="ngForm"
  name="webchatForm"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <h2>{{ titleText }}</h2>
  <p>
    {{ intro1Text }}
  </p>
  <p>
    {{ intro2Text }}
  </p>

  <mat-form-field fxFlex>
    <input
      fxFlex
      matInput
      [(ngModel)]="webchatChannelName"
      #webchatName="ngModel"
      name="webchatName"
      type="text"
      [placeholder]="namePlaceholder"
      required
    />
  </mat-form-field>

  <mat-divider class="webchat-settings-divider"></mat-divider>
  <app-webchat-settings
    [webchatSettings]="webchatSettings"
    (webchatSettingsChanged)="onWebchatSettingsChanged($event)"
  ></app-webchat-settings>

  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!webchatForm.form.valid"
  >
    {{ enableWebchatText }}
  </button>
</form>
